// src/utils/integrationHelpers.ts
export type MappingRow = {
    placeholder: string;
    mappedTo: {
      type: "model" | "custom";
      modelKey?: string;
      fieldKey?: string;
      value?: string;
    };
  };
  
  /**
   * Given an array of mapping rows and a lookup of modelKey→dataObject,
   * returns an array of resolved parameter values.
   */
  export function resolveParameters(
    rows: MappingRow[],
    dataSources: Record<string, Record<string, any>>
  ): Array<string | number> {
    return rows.map((row) => {
      const m = row.mappedTo;
      if (m.type === "model" && m.modelKey && m.fieldKey) {
        const src = dataSources[m.modelKey];
        return src ? src[m.fieldKey] : "";
      } else if (m.type === "custom") {
        return m.value || "";
      }
      return "";
    });
  }
  